import { defineStore } from 'pinia'
import Api from '../api/Api'

export const useTenantConnectionsStore = defineStore('tenantConnections', {
  state: () => ({
    homeTenantsList: [],
    awayTenantsList: [],
  }),
  getters: {
  },
  actions: {
    async refreshHomeTenantsList(rootNodeId) {
      const response = await Api.tenantConnections.getHomeTenantsList(rootNodeId);
      this.homeTenantsList = response.data;
    },
    async refreshAwayTenantsList(rootNodeId) {
      const response = await Api.tenantConnections.getAwayTenantsList(rootNodeId);
      this.awayTenantsList = response.data;
    },

    async requestTenantConnection(rootNodeId, payload) {
      return await Api.tenantConnections.requestTenantConnection(rootNodeId, payload)
    },

    async updateHomeTenantConnection(rootNodeId, tenantConnectionId, payload) {
      return await Api.tenantConnections.updateHomeTenantConnection(rootNodeId, tenantConnectionId, payload);
    },

    async completeTenantConnection(rootNodeId, payload) {
      return await Api.tenantConnections.completeTenantConnection(rootNodeId, payload);
    },

    async awayTenantSaveGroups(rootNodeId, connectionId, payload) {
      const response = await Api.tenantConnections.awayTenantSaveGroups(rootNodeId, connectionId, payload);
      const tenantConnection = response.data;

      // TODO: Update the record in the away tenant list
      const index = this.awayTenantsList.findIndex((item) => item.id === connectionId);
      if (index !== -1) {
        this.awayTenantsList[index] = tenantConnection;
      }

      return tenantConnection;
    },

    async awayTenantGetUsers(rootNodeId, connectionId) {
      const response = await Api.tenantConnections.awayTenantGetUsers(rootNodeId, connectionId);
      return response.data;
    },

    async awayTenantUpdateUsers(rootNodeId, connectionId, payload) {
      const response = await Api.tenantConnections.awayTenantUpdateUsers(rootNodeId, connectionId, payload);
      return response;
    },

    async removeTenantConnection(rootNodeId, connectionId) {
      return await Api.tenantConnections.removeTenantConnection(rootNodeId, connectionId);
    }
  },
})
